import { BOOTSTRAP_STATE_DATA } from '../actions';

export default (stateData) => ({
  type: BOOTSTRAP_STATE_DATA,
  stateData,
});
